import React, { useEffect, useState } from 'react';
import { useTranslation } from '../i18n/LanguageContext';
import { TwoFactorPolicyFields, toTwoFactorMode, LoginPuzzlePolicyFields, toLoginPuzzleMode } from '../modules/security';
import { apiJson } from './twoFactorShared';

// Ayarlar > Güvenlik (yalnızca sistem admini) — 2FA politikası (madde 12). Bileşen ortak güvenlik
// modülünden; backend /api/admin/security/2fa-policy (backend/src/twoFactor.js).
// TrendSniper'da "yönetici" = sistem admini, "herkes" = sistem admini + viewer + e-posta/şifre
// kullanıcıları (Google ile girenler Google'ın kendi doğrulamasını kullanır).
export default function SecuritySettings({ token }) {
  const { t } = useTranslation();
  const [mode, setMode] = useState('OFF');
  const [smsEnabled, setSmsEnabled] = useState(false);
  const [otpSet, setOtpSet] = useState(false);
  const [puzzleMode, setPuzzleMode] = useState('SUSPICIOUS');
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    apiJson('GET', '/api/admin/security/2fa-policy', undefined, token)
      .then((d) => { setMode(toTwoFactorMode(d.mode)); setSmsEnabled(!!d.smsEnabled); setOtpSet(!!d.otpPasswordSet); })
      .catch((e) => setMsg({ type: 'error', text: e.message }));
    apiJson('GET', '/api/admin/security/login-puzzle-policy', undefined, token)
      .then((d) => setPuzzleMode(toLoginPuzzleMode(d.mode)))
      .catch(() => {});
  }, [token]);

  const save = async () => {
    setSaving(true); setMsg(null);
    try {
      await apiJson('PUT', '/api/admin/security/2fa-policy', { mode, smsEnabled }, token);
      await apiJson('PUT', '/api/admin/security/login-puzzle-policy', { mode: puzzleMode }, token);
      setMsg({ type: 'ok', text: t('tfa.policySaved') });
    } catch (e) {
      setMsg({ type: 'error', text: e.message });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="sms-settings ts-security">
      <TwoFactorPolicyFields
        editable
        mode={mode}
        onModeChange={setMode}
        smsEnabled={smsEnabled}
        onSmsEnabledChange={setSmsEnabled}
        strings={{
          title: t('tfa.policyTitle'),
          hint: t('tfa.policyHint'),
          policyLabel: t('tfa.policyLabel'),
          modes: {
            OFF: t('tfa.modeOff'),
            OPTIONAL: t('tfa.modeOptional'),
            REQUIRED_ADMINS: t('tfa.modeAdmins'),
            REQUIRED_STAFF: t('tfa.modeAll'),
          },
          smsLabel: t('tfa.smsLabel'),
        }}
        classNames={{ title: 'sms-section-title', hint: 'settings-hint', checkbox: 'ts-tfa-checkbox' }}
      />
      {smsEnabled && !otpSet && <p className="settings-hint">{t('tfa.smsNeedsOtp')}</p>}

      {/* Giriş yapbozu (modül 1.6.0) — backend/src/loginPuzzle.js */}
      <LoginPuzzlePolicyFields
        editable
        mode={puzzleMode}
        onModeChange={setPuzzleMode}
        strings={{
          title: t('tfa.puzzleTitle'),
          hint: t('tfa.puzzleHint'),
          policyLabel: t('tfa.puzzleLabel'),
          modes: { OFF: t('tfa.puzzleOff'), SUSPICIOUS: t('tfa.puzzleSuspicious'), ALWAYS: t('tfa.puzzleAlways') },
        }}
        classNames={{ title: 'sms-section-title', hint: 'settings-hint' }}
      />
      <div className="settings-footer" style={{ position: 'static' }}>
        {msg && <span className={`settings-msg settings-msg-${msg.type}`}>{msg.text}</span>}
        <button className="btn btn-start" style={{ minWidth: 120 }} onClick={save} disabled={saving}>
          {saving ? t('settings.saving') : t('settings.save')}
        </button>
      </div>
    </div>
  );
}
